export default __webpack_public_path__ + "static/media/neofin.alt.fea69167.png";